import React from "react";
import SetPassword from "./SetPassword";
import WelcomeTitle from "./parts/WelcomeTitle";

/**
 * Component render SetPassword Component with pageTitle and pageSubTitle
 */

//All logic is inside --> SetPassword <-- component
const Registration = () => {
	const pageTitle = <WelcomeTitle />;
	let pageSubTitle = "Enter your password and complete registration.";

	return <SetPassword pageTitle={pageTitle} pageSubTitle={pageSubTitle} />;
};

export default Registration;
